<template>
    <CRow>
        <CCol col="12" lg="8">
            <CCard>
                <CCardHeader>
                    <strong
                    >{{ promotion.title }}</strong
                    >
                </CCardHeader>
                <CCardBody>
                    <PromotionsTabLinks />

                    <CRow class="ml-1 mt-3">
                        <p>Чтобы активировать акцию для всех клиентов, необходимо создать клиента с номером телефона "all" и сделать его активным.</p>
                    </CRow>
                    <CRow class="ml-1 mt-3">
                        <p>Чтобы акция не была активна для всех клиентов, достаточно деактивировать клиента с номером телефона "all".</p>
                    </CRow>
                    <CRow class="ml-1 mt-3" />
                    <CDataTable
                        hover
                        column-filter
                        sorter
                        striped
                        :items="clients"
                        :fields="fields"
                        :items-per-page="10"
                        :active-page="activePage"
                        :pagination="{ doubleArrows: true, align: 'center' }"
                        clickable-rows
                        @page-change="pageChange"
                        @row-clicked="rowClicked"
                    >
                        <template #phone="data">
                            <td>
                                <strong>{{ data.item.phone }}</strong>
                            </td>
                        </template>
                        <template #name="data">
                            <td>{{ data.item.name ? data.item.name : "" }}</td>
                        </template>
                        <template #time_from="data">
                            <td>
                                {{
                                    data.item.time_from
                                        ? data.item.time_from
                                        : ""
                                }}
                            </td>
                        </template>
                        <template #time_to="data">
                            <td>
                                {{ data.item.time_to ? data.item.time_to : "" }}
                            </td>
                        </template>
                        <!-- <template #discount="data">
                            <td>{{ parseInt(data.item.discount) }} %</td>
                        </template> -->
                        <template #enabled="data">
                            <td>
                                <CBadge
                                    :color="getBadge(data.item.enabled)"
                                >&nbsp;{{
                                    data.item.enabled ? "Да" : "Нет"
                                }}&nbsp;</CBadge
                                >
                            </td>
                        </template>
                    </CDataTable>
                </CCardBody>
                <CCardFooter>
                    <CButton
                        color="primary"
                        class="mr-3"
                        @click="showCreateModal"
                    >Создать</CButton
                    >
                </CCardFooter>
            </CCard>
        </CCol>

        <CModal
            :title="`${modal.title}`"
            :show.sync="modal.show"
            :footer="false"
        >
            <template>
                <div slot="body-wrapper" class="modal-body">
                    <CForm>
                        <CRow form class="form-group">
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Имя
                            </CCol>
                            <CCol sm="9">
                                <CInput v-model="modal.client.name" />
                            </CCol>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Телефон
                            </CCol>
                            <CCol sm="9">
                                <CInput v-model="modal.client.phone" />
                            </CCol>
                            <!-- <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Скидка
                            </CCol>
                            <CCol sm="9">
                                <CInput v-model="modal.client.discount" />
                            </CCol> -->
                            <!-- <CCol tag="label" sm="3" class="col-form-label">
                                Время (от)
                            </CCol>
                            <CCol sm="9">
                                <CInput v-model="modal.client.time_from" />
                            </CCol>
                            <CCol tag="label" sm="3" class="col-form-label">
                                Время (до)
                            </CCol>
                            <CCol sm="9">
                                <CInput v-model="modal.client.time_to" />
                            </CCol> -->
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Активен
                            </CCol>
                            <CCol sm="9">
                                <CSwitch
                                    color="light"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="modal.client.enabled"
                                />
                            </CCol>
                        </CRow>
                    </CForm>
                </div>
                <div slot="footer">
                    <CButton
                        color="primary"
                        class="ml-3"
                        @click="save">{{
                            modal.buttonText
                        }}</CButton>
                    <CButton
                        color="light"
                        class="ml-3"
                        @click="modal.show = false"
                    >Отмена</CButton
                    >
                    <CButton
                        v-if="modal.client.id"
                        color="danger"
                        class="ml-3"
                        @click="deleteClient"
                    >Удалить</CButton
                    >
                </div>
            </template>
        </CModal>
    </CRow>
</template>

<script>
    import Vue from 'vue';
    import PromotionsTabLinks from '@/components/promotions/CommonPromotionsTabLinks';
    import { getRouteName } from '../../../utils/route-name';

    export default {
        name: 'PromotionClients',

        components: {
            PromotionsTabLinks,
        },

        data() {
            return {
                service: {},
                promotion: {},
                clients: [],
                fields: [
                    {
                        key: 'phone',
                        label: 'Телефон',
                        _classes: 'font-weight-bold',
                    },
                    { key: 'name', label: 'Имя' },
                    // { key: 'discount', label: 'Скидка' },
                    // { key: "time_from", label: "Время (от)" },
                    // { key: "time_to", label: "Время (до)" },
                    { key: 'enabled', label: 'Активен' },
                ],
                activePage: 1,
                modal: {
                    title: 'Создать клиента',
                    show: false,
                    buttonText: 'Создать',
                    client: {
                        id: null,
                        name: '',
                        phone: '',
                        discount: null,
                        time_from: 0,
                        time_to: 0,
                        enabled: true,
                    },
                },
            };
        },

        computed: {},

        mounted() {
            const promotionId = parseInt(this.$route.params.id);
            Vue.axios
                .get('/common-promotions/' + promotionId)
                .then(resp => {
                    this.promotion = resp.data;
                })
                .catch(() => {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                });
            Vue.axios
                .get('/promotions/' + promotionId + '/clients')
                .then(resp => {
                    this.clients = resp.data;
                })
                .catch(() => {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                });
        },

        methods: {
            showCreateModal() {
                this.modal.title = 'Создание клиента';
                this.modal.client = {
                    id: null,
                    name: '',
                    phone: '',
                    discount: '',
                    time_from: 0,
                    time_to: 0,
                    enabled: true,
                };
                this.modal.buttonText = 'Создать';
                this.modal.show = true;
            },

            rowClicked(item) {
                this.modal.title = 'Редактирование клиента';
                this.modal.client = item;
                this.modal.client.enabled = Boolean(item.enabled);
                this.modal.buttonText = 'Сохранить';
                this.modal.show = true;
            },

            deleteClient() {
                // ToDo
                Vue.axios
                    .delete(
                        '/promotions/' +
                            this.promotion.id +
                            '/clients/' +
                            this.modal.client.id
                    )
                    .then(() => {
                        // Nothing to do
                        this.reloadClients();
                    })
                    .catch(err => {
                        this.$root.$emit('showError', 'Ошибка удаления.');
                    });
            },

            save() {
                this.modal.client.enabled = this.modal.client.enabled
                    ? true
                    : false;
                this.modal.client.promotion_id = this.promotion.id;
                this.modal.client.discount = parseInt(this.modal.client.discount);
                if (this.modal.client.id) {
                    // Update
                    Vue.axios
                        .put(
                            '/promotions/' +
                                this.promotion.id +
                                '/clients/' +
                                this.modal.client.id,
                            this.modal.client
                        )
                        .then(() => {
                            // Nothing to do
                            this.reloadClients();
                        })
                        .catch(() => {
                            this.$root.$emit('showError', 'Ошибка сохранения.');
                        });
                } else {
                    // Create
                    Vue.axios
                        .post(
                            '/promotions/' + this.promotion.id + '/clients',
                            this.modal.client
                        )
                        .then(() => {
                            // Nothing to do
                            this.reloadClients();
                        })
                        .catch(err => {
                            this.$root.$emit('showError', 'Ошибка сохранения.');
                        });
                }
            },

            reloadClients() {
                Vue.axios
                    .get('/promotions/' + this.promotion.id + '/clients')
                    .then(resp => {
                        this.clients = resp.data;
                    })
                    .catch(() => {
                        this.$root.$emit('showError', 'Ошибка загрузки данных.');
                    });
                this.modal.show = false;
            },

            getBadge(status) {
                return status ? 'success' : 'secondary';
            },

            pageChange(val) {
                this.$router.push({ query: { page: val } });
            },
        },
    };
</script>
<style scoped>
</style>
